import type { DocumentNode } from 'graphql'
import { gql } from 'graphql-tag'
import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core'

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables> {
  __apiType?: DocumentTypeDecoration<TResult, TVariables>['__apiType']

  constructor(private value: string, public __meta__?: Record<string, unknown>) {
    super(value)
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value
  }

  gql = (): DocumentNode => {
    const res = gql(this.value)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ;(res as any)['__meta__'] = { hash: this.hash() }
    return res
  }

  hash = (): string | undefined => helpers.toString2(this.__meta__?.hash)

  static getQueryDocument = (doc: MyDocumentNode): DocumentNode => {
    return doc instanceof TypedDocumentString ? doc.gql() : doc
  }
}

export type MyDocumentNode = DocumentNode | TypedDocumentString<unknown, unknown>
